'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    tabData: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    active: {
      type: Number,
      required: false,
      default: null
    },
    // 背景色
    bgColor: {
      type: String,
      required: false,
      default: '#151617'
    },
    // 选择状态边框颜色
    activeBorderColor: {
      type: String,
      required: false,
      default: '#b35336'
    },
    // 字体大小
    textFontSize: {
      type: String,
      required: false,
      default: '28px'
    },
    // 字体颜色
    textColor: {
      type: String,
      required: false,
      default: 'rgba(255,255,255,0.40)'
    },
    // 选中态字体颜色
    activeTextColor: {
      type: String,
      required: false,
      default: 'rgba(255, 255, 255, 0.8)'
    },
    // 常规边框颜色
    borderColor: {
      type: String,
      required: false,
      default: 'rgba(61, 61, 66, 1)'
    },
    // 点击颜色
    touchColor: {
      type: String,
      required: false,
      default: '#2d2e2f'
    },
    // 高度
    itemHeight: {
      type: Number,
      default: 64
    },
    // 限制字数，超出省略号（0为默认）
    maxLen: {
      type: Number,
      default: 0
    },
    // 是否撑开
    isFlexible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _tabData: function _tabData() {
      return this.tabData.map(function (item) {
        return typeof item === 'string' ? { label: item } : item;
      });
    },
    dataLen: function dataLen() {
      return this.tabData.length;
    },
    labelMaxLen: function labelMaxLen() {
      if (this.maxLen) return this.maxLen;
      // 超过3个标签字数最多2个字
      if (this.tabData.length > 3) return 2;
      // 默认4个字
      return 4;
    },
    borderRadius: function borderRadius() {
      return this.itemHeight / 2 + 'px';
    },
    tabLineStyle: function tabLineStyle() {
      return {
        width: this.itemHeight / 4 + 1 + 'px',
        height: this.itemHeight + 'px'
      };
    },
    maskStyle: function maskStyle() {
      return {
        width: this.itemHeight + 2 + 'px',
        height: this.itemHeight + 2 + 'px'
      };
    },
    fakeBorderStyle: function fakeBorderStyle() {
      return {
        width: this.itemHeight / 4 + 2 + 'px'
      };
    }
  },
  watch: {
    active: {
      handler: function handler(val, oldVal) {
        this.tabActive = val;
      }
    },
    tabActive: function tabActive(val) {
      this.$emit('tabActiveChange', val);
    }
  },
  data: function data() {
    return {
      tabActive: this.active,
      touchActive: null,
      isAndroid: _utils2.default.env.isAndroid()
    };
  },
  mounted: function mounted() {},

  methods: {
    clickTabItem: function clickTabItem(i) {
      this.tabActive = i;
    },
    touchTabItem: function touchTabItem(i) {
      this.touchActive = i;
    },
    touchEnd: function touchEnd() {
      this.touchActive = null;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-diamond-tab/index.vue
// module id = 332
// module chunks = 0 1